import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const $document = $(document);
const $alerts = $('.alerts');
const $alertsWrapper = $('.alerts__wrapper');
const lang = $alerts.data('lang');

$(function () {
    $alertsWrapper.on('scroll', alertsOverflow);
    $window.on('resize', debounce(alertsOverflow));
});

$document.on('click', '.alert__dismiss', function () {
    const $alert = $(this).closest('.alert');
    $alert.removeClass('active').one('transitionend', function () {
        $alert.slideUp(200, function () {
            $alert.remove();
            alertsOverflow();
        });
    });
});

document.addEventListener('alert', function (event) {
    let type = event.detail.type;
    let msg = '';
    let label = '';

    if (lang === 'sk') {
        msg = event.detail.msg;
        label = 'Zatvoriť upozornenie';
    } else {
        msg = event.detail.msgEn;
        label = 'Dismiss alert';
    }

    $alertsWrapper
        .animate({ scrollTop: 0 }, 300)
        .prepend(
            '<div class="alert ' +
                type +
                '">' +
                '<div class="alert__content">' +
                '<div class="alert__msg">' +
                msg +
                '</div>' +
                '<button class="alert__dismiss" title="' +
                label +
                '" aria-label="' +
                label +
                '">' +
                '<svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M15.6871 14.9969L29.8584 0.82567C30.0473 0.6367 30.0473 0.330491 29.8584 0.141639C29.6694 -0.0472131 29.3632 -0.0472131 29.1744 0.141639L15.0031 14.3128L0.831727 0.141639C0.639582 -0.0440381 0.333373 -0.0386289 0.147696 0.153516C-0.0333954 0.340957 -0.0333954 0.638229 0.147696 0.82567L14.319 14.997L0.147696 29.1682C-0.044449 29.3539 -0.0498582 29.6601 0.135819 29.8522C0.321496 30.0444 0.627705 30.0498 0.81985 29.8641C0.823848 29.8602 0.827846 29.8562 0.831727 29.8522L15.0031 15.6809L29.1744 29.8522C29.3665 30.0379 29.6727 30.0326 29.8584 29.8404C30.0395 29.6529 30.0395 29.3556 29.8584 29.1682L15.6871 14.9969Z" fill="black"/>' +
                '</svg>' +
                '</button>' +
                '</div>' +
                '</div>'
        );

    const $newAlert = $alertsWrapper.children().first();

    $newAlert.slideDown(
        {
            start: function () {
                $(this).css({
                    display: 'grid',
                });
            },
            done: function () {
                $newAlert.addClass('active');
                alertsOverflow();
            },
        },
        200
    );
});

const alertsScrolledTop = () => $alertsWrapper.scrollTop() === 0;
const alertsScrolledBottom = () => Math.ceil($alertsWrapper.scrollTop() + $alertsWrapper.outerHeight()) >= Math.ceil($alertsWrapper[0].scrollHeight);

const alertsOverflow = () => {
    if (alertsScrolledTop() && alertsScrolledBottom()) {
        $alerts.addClass('alerts-are-up alerts-are-down');
    } else {
        if (alertsScrolledTop()) {
            $alerts.addClass('alerts-are-up');
        } else {
            $alerts.removeClass('alerts-are-up');
        }

        if (alertsScrolledBottom()) {
            $alerts.addClass('alerts-are-down');
        } else {
            $alerts.removeClass('alerts-are-down');
        }
    }
};
